import styles from './IconMenu.module.scss';

type Props = {
  isOpen: boolean;
  className?: string;
  onClick?: () => void;
};

export function IconMenu({ isOpen, className, onClick }: Props) {
  return (
    <button
      className={`${styles.burger} ${isOpen ? styles.open : ''} ${className || ''}`}
      onClick={onClick}
    >
      <span></span>
      <span></span>
    </button>
  );
}